import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RsFormatPaginatedListRequestBody, RsUtils } from '@lib/rs-ngx';
import { WorkOrderSummary } from '@app/admin/work-orders/shared/models/work-order-summary';
import { GetWorkOrderQueryParams } from '@app/admin/work-orders/shared/models/work-order-parameters';
import { rsFormatPaginatedListRequestBody } from '@lib/utils/custom-rxjs-operators/rsFormatPaginatedListRequestBody';

@Injectable()
export class WorkOrderService {
  private readonly http = inject(HttpClient);

  public readonly getWorkOrders = (queryParams: GetWorkOrderQueryParams): Observable<RsFormatPaginatedListRequestBody<WorkOrderSummary[]>> => {
    const params = RsUtils.trimEmptyHttpParams(queryParams);
    return this.http
      .get<WorkOrderSummary[]>(
        `${environment.apiUrl}/admin/work-order`,
        { observe: 'response', params }
      ).pipe(
        rsFormatPaginatedListRequestBody()
      );
  }
}
